export default __webpack_public_path__ + "static/media/img2.22ce30ce.png";